import React, { useEffect } from "react";
import Chart from "chart.js/auto";

const RevenueChart = ({ revenueData }) => {
  useEffect(() => {
    const canvas = document.getElementById("revenueChart");
    // destroy any existing chart on this canvas
    const existing = Chart.getChart(canvas);
    if (existing) existing.destroy();

    const ctx = canvas.getContext("2d");
    const chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        datasets: [
          {
            label: "Monthly Revenue",
            data: revenueData,
            backgroundColor: "rgba(0, 128, 128, 0.6)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 2,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        scales: { x: {}, y: { beginAtZero: true } },
        plugins: { legend: { display: true, position: "top" } },
      },
    });

    return () => chart.destroy();
  }, [revenueData]);

  return <canvas id="revenueChart"></canvas>;
};

export default RevenueChart;
